import React from 'react';

import Select from '@atlaskit/select';

import { IS_CLOUD } from '@qality/common-config';
import { TestStepsView } from '@qality/common-model';
import { ViewService } from '@qality/common-service';

import './_change-view.scss';

type Props = {
  value: TestStepsView;
  onChange: (value: TestStepsView) => void;
  isInDialog?: boolean;
};
export default function ChangeView({
  value,
  onChange,
  isInDialog = false,
}: Props): JSX.Element {
  return (
    <Select
      value={value}
      onChange={onChange}
      className='change-view-select'
      classNamePrefix='react-select'
      options={ViewService.getViewTypeOptions()}
      placeholder='Choose view'
      spacing='compact'
      isSearchable={false}
      // Fix for conflict with the description field
      menuPortalTarget={isInDialog && IS_CLOUD && document.body}
      styles={
        isInDialog &&
        IS_CLOUD && {
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
            transform: 'translate(-10px, -30px)',
          }),
        }
      }
      // -----
    />
  );
}
